import queryString from 'query-string';

export function getApplyIdFromQuery(query: string): string | null {
  const params = queryString.parse(query);
  if ('string' === typeof params.apply_id) {
    return params.apply_id;
  } else {
    return null;
  }
}
